

// Third party libraries
import { Form, Row, InputGroup, Col, Table, Spinner, Button, Badge, Modal } from "react-bootstrap";
import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment/moment";
import "./index.css";
import _ from "lodash";

// components
import { errorSwal, successDeleteSwal } from "../../../helper/sweetalert";
import AnimationLoading from "../../../components/Animationloading";
import PaginationHelper from "../../../components/PaginationHelper";
import { convertCurrency, convertOrderStatus, covertTimeZone, numberFormat } from "../../../helper";
import EmptyComponent from "../../../components/EmptyComponent";
import CustomButton from "../../../components/CustomButton";
import ComfirmModal from "../../../components/ComfirmModal";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { LINEAR_GRADIENT_BG } from "../../../const";
import CurrentDateComponents from "../../../components/CurrentDateComponents";
import { DELETE_ORDERGROUP, UPDATE_ORDER_GROUP_DETAIL } from "../../../apollo/ordergroup/mutation";
import { GET_ORDERGROUP_BATCH, GET_ORDER_GROUPS_V2 } from "../../../apollo/ordergroup/query";
import { GET_USER_TYPE } from "../../../apollo/userType/mutation";

// Icons
// import { BsFillCheckCircleFill } from "react-icons/bs";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { MdOutlineDateRange } from "react-icons/md";
// import { ImCancelCircle } from "react-icons/im";
import { GET_CATEGORYS } from "../../../apollo/category/query";
import { GET_EXCHANGE_RATE } from "../../../apollo/product/query";
import useWindowDimensions from "../../../helper/windowDimensions";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx/xlsx.mjs";

export default function SaleHistory() {
  const history = useHistory();
  const client = useApolloClient();
  const location = useLocation();

  //========================================================== 
  const [ordergroup, setOrderGroup] = useState();
  const [ordergroupToltal, setOrderGroupTotal] = useState();
  //========================================================== 

  const { rolePermissions } = useSelector((state) => state.permissions);
  const { width } = useWindowDimensions()
  const { t } = useTranslation()
  const ordersAbortRef = useRef(null);

  const [searchText, setSearchText] = useState("");
  const [payment, setPayment] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisMonth"); //useState("thisMonth");
  const [filter, setFilter] = useState({
    createdAt_gte: '',
    createdAt_lt: '',
  });
  //? user type useState
  const [newUserTypeData, setNewUserTypeData] = useState();
  const [selectUserType, setSelectUserType] = useState("");
  //? Category useState
  const [newCategoryData, setNewCategoryData] = useState();
  const [isCategory, setIsCategory] = useState("");
  const [isCategoryName, setIsCategoryName] = useState("");

  //? Edit order useState
  const [showEdit, setShowEdit] = useState(false);
  const [editOrderId, setEditOrderId] = useState("");
  const [editCheckBillDate, setEditCheckBillDate] = useState("");
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectStatus, setSelectStatus] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [exportMode, setExportMode] = useState("");
  const [
    getExchangeRate,
    { data: exchangeRateData, loading: exchangeRateLoading },
  ] = useLazyQuery(GET_EXCHANGE_RATE, { fetchPolicy: "cache-and-network" });
  const exchangeRateByShop = exchangeRateData?.exchangeRate || {};
  const calculateSumKipFromOrders = (orders = [], salehis) => {
    return orders.reduce((sum, order) => {
      const base = parseFloat(salehis?.sumPrice || 0);
      const cur = order?.currency || order?.stock?.currency;
      if (cur === "LAK" || cur === "ກີບ") return sum + base;
      if (cur === "BAHT" || cur === "ບາດ") return sum + base * parseFloat(salehis?.rateBaht || 1);
      if (cur === "USD" || cur === "ໂດລາ") return sum + base * parseFloat(salehis?.rateUsd || 1);
      return sum + base;
    }, 0);
  };

  // ============== > UseLazyQuery And UseMutaion <==============
  const [getOrders, { data: orderGroupsData, loading: loadingSaleOrder }] = useLazyQuery(
    GET_ORDER_GROUPS_V2,
    { fetchPolicy: "cache-and-network" }
  );
  const [userTypeData, { data: getUserTypeData, loading: getUserTypeLoading }] =
    useLazyQuery(GET_USER_TYPE, { fetchPolicy: "cache-and-network" });

  const [getCategories, { data: getCategoryData, loading: getCategoryLoading }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "cache-and-network" }
  );

  // ============== > UseLazyQuery And UseMutaion <==============

  const [deleteordergroup, { loading: deleteloading }] =
    useMutation(DELETE_ORDERGROUP);

  const [updateOrderGroupDetail, { loading: updateLoading }] =
    useMutation(UPDATE_ORDER_GROUP_DETAIL);

  // ============== > useEffect <==============

  useEffect(() => {
    if (orderGroupsData) {
      setOrderGroup(orderGroupsData?.orderGroupsV2?.data);
      setOrderGroupTotal(orderGroupsData?.orderGroupsV2?.total);
    }
  }, [orderGroupsData]);

  useEffect(() => {
    fetchSaleHistoryData();
    getCategory();
    userTypeData();
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    if (shopId) {
      getExchangeRate({ variables: { where: { shop: shopId } } });
    }
    return () => {
      if (ordersAbortRef.current) {
        ordersAbortRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    const categories = getCategoryData?.categories?.data;
    if (categories) {
      const result = [...categories].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setNewCategoryData(result);
    }
  }, [getCategoryData]);

  useEffect(() => {
    fetchSaleHistoryData();
  }, [
    filter,
    payment,
    _skip,
    _limit,
    isCategory,
    selectUserType,
    selectStatus
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchSaleHistoryData();
    }, 250);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchText]);

  //? user type useEffect
  useEffect(() => {
    if (getUserTypeData?.getUserTypes) {
      const data = getUserTypeData?.getUserTypes.filter((item) => item?.isOpen);
      setNewUserTypeData(data);
    }
  }, [getUserTypeData?.getUserTypes]);

  //======================useEffect==========================================

  // ============== > fuctions <==============

  const buildWhere = () => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    let _where = {
      shop: shopId,
      isDeleted: false,
      type: "POS",
    };

    if (selectStatus === "ALL") {
      // No status filter for "ALL"
    } else if (selectStatus === "") {
      _where = { ..._where, statusNin: ["INDEBTED"] };
    } else {
      _where = { ..._where, status: selectStatus };
    }

    if (searchText !== "") {
      _where = {
        ..._where,
        searchKeyWord: searchText,
      };
    }

    if (isCategory !== "") {
      _where = {
        ..._where,
        category: isCategory,
        categoryName: isCategoryName,
      };
    }

    if (payment !== "") {
      _where = {
        ..._where,
        payment: payment,
      };
    }

    if (selectUserType !== "") {
      _where = { ..._where, userType: selectUserType };
    }

    if (filter?.createdAt_gte && filter?.createdAt_lt) {
      _where = {
        ..._where,
        createdAt_gte: moment(filter?.createdAt_gte).format("YYYY-MM-DD"),
        createdAt_lt: moment(filter.createdAt_lt)
          .add(1, "days")
          .format("YYYY-MM-DD"),
      };
    } else {
      _where = {
        ..._where,
        createdAt_gte: moment().startOf("month").format("YYYY-MM-DD"),
        createdAt_lt: moment().endOf("month").format("YYYY-MM-DD")
      };
    }

    return _where;
  };

  const fetchSaleHistoryData = async () => {
    try {
      if (ordersAbortRef.current) {
        ordersAbortRef.current.abort();
      }
      ordersAbortRef.current = new AbortController();
      const signal = ordersAbortRef.current.signal;

      const _where = buildWhere();

      await getOrders({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: _limit,
          orderBy: "createdAt_DESC",
        },
        context: { fetchOptions: { signal } },
      });

    } catch (error) {
      if (error?.name !== "AbortError") {
        console.log("Error:", error);
      }
    }
  };

  //? Category call API
  const getCategory = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const response = await getCategories({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });

      const categories = response?.data?.categories?.data;
      if (!_.isEmpty(categories)) {
        const result = [...categories].sort((a, b) =>
          a?.name?.localeCompare(b?.name)
        );
        setNewCategoryData(result);
      }

    } catch (error) {
      console.log("Error:", error);
    }
  };
  //========TODO: Get all order groups============ 

  const handleShowDelete = (id, code) => {
    setDelete({ id, code });
    setShowDelete(true);
  };

  const handleShowEdit = (orderData) => {
    
    setEditOrderId(orderData?.id);
    
    // Format checkBillDate for datetime-local input
    let formattedDate = "";
    if (orderData?.checkBillDate) {
      // Convert UTC time to local time for datetime-local input (YYYY-MM-DDTHH:mm)
      formattedDate = moment.utc(orderData.checkBillDate).local().format("YYYY-MM-DDTHH:mm");
    }
    
    setEditCheckBillDate(formattedDate);
    setSelectedOrderData(orderData);
    setShowEdit(true);
  };

  const handleEditSubmit = () => {
    setShowEdit(false);
    setShowConfirm(true);
  };

  const handleConfirmEdit = async () => {
    try {
      if (updateLoading) return;
      
      // Convert local datetime to UTC for server
      const utcDateTime = moment(editCheckBillDate).utc().toISOString();
      
      const result = await updateOrderGroupDetail({
        variables: {
          where: {
            id: editOrderId,
          },
          data: {
            checkBillDate: utcDateTime,
          },
        },
      });

      if (result?.data?.updateOrderGroupDetail?.status === true) {
        // Update local data with response data
        const updatedData = result?.data?.updateOrderGroupDetail?.data;
        if (updatedData) {
          // Update the ordergroup state with the new data
          setOrderGroup(prevOrdergroup => 
            prevOrdergroup.map(order => 
              order.id === editOrderId 
                ? { ...order, ...updatedData }
                : order
            )
          );
        }
        
        successDeleteSwal("ອັບເດດສຳເລັດ");
        
        // Close modal automatically
        setShowConfirm(false);
        setShowEdit(false);
        setEditOrderId("");
        setEditCheckBillDate("");
        setSelectedOrderData(null);
      } else {
        errorSwal(result?.data?.updateOrderGroupDetail?.msg || "ອັບເດດບໍ່ສຳເລັດ");
      }
    } catch (err) {
      errorSwal(err?.message || "ເກີດຂໍ້ຜິດພາດ");
      setShowConfirm(false);
    }
  };

  const _confirmeDelete = async () => {
    try {
      if (deleteloading) return;
      await deleteordergroup({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      fetchSaleHistoryData();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal(err);
    }
  };

  const handleCheck = (data) => {
    history.push("/order_detail", {
      state: data,
    })
  }

  const formatBillCode = (salehis) => {
    const code = salehis?.code ?? "";
    return code
  };

  const handleSelectLimit = (e) => {
    const _values = e?.target?.value;
    let pathname = location.pathname;
    pathname = pathname.replace(/(\/limit\/)\d+/, `/limit/${_values}`);
    pathname = pathname.replace(/(\/page\/)\d+/, "/page/1");
    history.replace(pathname);
  };

  const buildExportRows = (exportData, startIndex = 0) => {
    const rows = [];
    exportData.forEach((salehis, index) => {
      const categories = salehis?.orders && salehis?.orders?.length > 0
        ? (!_.isEmpty(Array.from(new Set(salehis?.orders.map(order => order?.stock?.category?.name).filter(Boolean))).join(', '))
          ? Array.from(new Set(salehis?.orders.map(order => order?.stock?.category?.name).filter(Boolean))).join(', ')
          : Array.from(new Set(salehis?.orders.map(order => order?.stock?.categoryName).filter(Boolean))).join(', '))
        : '-';

      const baseRow = {
        ລຳດັບ: startIndex + index + 1,
        ເລກທີບິນ: salehis?.code ?? "",
        ຊື່ພະນັກງານ: (`${salehis?.createdBy?.firstName ?? ""} ${salehis?.createdBy?.lastName ?? ""}`.trim() || `${salehis?.staff ?? ""} ${salehis?.staffLastname ?? ""}`.trim() || "-"),
        ລະຫັດພະນັກງານ: salehis?.createdBy?.staffCode ?? "-",
        ຊື່ລູກຄ້າ: salehis?.customerName ?? "-",
        ປະເພດລູກຄ້າ: salehis?.userConfirm?.userType?.name ?? "-",
        ປະເພດສິນຄ້າ: categories,
        ເບີໂທ: salehis?.phone ?? "-",
        ຈຳນວນ: salehis?.amount ?? "",
        ລາຄາລວມ: salehis?.receivedMoney || salehis?.sumPrice || 0,
        ສະກຸນເງິນ: convertCurrency("LAK"),
        ການຈ່າຍ: salehis?.payment === "CASH"
          ? t("cash_money_name")
          : t("transfer_money_name"),
        ສະຖານະ: convertOrderStatus(salehis?.status) ?? "",
        ວັນທີ: covertTimeZone(salehis?.createdAt),
        ໝາຍເຫດ: salehis?.note ?? "",
      };

      const orders = salehis?.orders?.filter(o => !o?.isDeleted) || [];
      if (orders.length === 0) {
        rows.push({ ...baseRow, ຂະໜາດ: "", ຈຳນວນສິນຄ້າ: "", ຊື່ສິນຄ້າ: "", ຈຳນວນຂອງແຖມ: "", ຊື່ຂອງແຖມ: "", ລາຄາສິນຄ້າ: "", ລາຄາລວມສິນຄ້າ: "" });
      } else {
        orders.forEach((order, orderIdx) => {
          const size = order?.stock?.size || "";
          const unitName = order?.stock?.unitId?.name || order?.stock?.unit || "";
          const sizeDisplay = size ? `${size} ${unitName}` : unitName;
          const orderRow = {
            ...(orderIdx === 0 ? baseRow : {
              ລຳດັບ: "",
              ເລກທີບິນ: "",
              ຊື່ພະນັກງານ: "",
              ລະຫັດພະນັກງານ: "",
              ຊື່ລູກຄ້າ: "",
              ປະເພດລູກຄ້າ: "",
              ປະເພດສິນຄ້າ: "",
              ເບີໂທ: "",
              ຈຳນວນ: "",
              ລາຄາລວມ: "",
              ສະກຸນເງິນ: "",
              ການຈ່າຍ: "",
              ສະຖານະ: "",
              ວັນທີ: "",
              ໝາຍເຫດ: "",
            }),
            ຊື່ສິນຄ້າ: order?.productName ?? "",
            ຈຳນວນສິນຄ້າ: order?.amount ?? "",
            ຂະໜາດ: sizeDisplay,
            ຈຳນວນຂອງແຖມ: order?.children?.length
              ? order.children.map(c => `${c.amount || 0}`).join("\n")
              : "",
            ຊື່ຂອງແຖມ: order?.children?.length
              ? order.children.map(c => `${c.productName || ""}`).join("\n")
              : "",
            ລາຄາສິນຄ້າ: order?.price ?? 0,
            ລາຄາລວມສິນຄ້າ: order?.totalPrice ?? 0,
          };
          rows.push(orderRow);
        });
      }
    });
    return rows;
  };

  const handleExportExcel = async () => {
    try {
      if (isExporting) return;
      setExportMode("page");
      setIsExporting(true);
      if (!ordergroupToltal || ordergroupToltal <= 0) {
        errorSwal("ບໍ່ພົບຂໍ້ມູນ");
        return;
      }

      const _where = buildWhere();
      const result = await client.query({
        query: GET_ORDER_GROUPS_V2,
        variables: {
          where: _where,
          skip: 0,
          limit: _limit,
          orderBy: "createdAt_DESC",
        },
        fetchPolicy: "network-only",
      });

      const exportData = result?.data?.orderGroupsV2?.data || [];
      const rows = buildExportRows(exportData, _limit * (_skip - 1));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `sale_history_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    } catch (error) {
      console.log("Export Error:", error);
      errorSwal("ສົ່ງອອກບໍ່ສຳເລັດ");
    } finally {
      setExportMode("");
      setIsExporting(false);
    }
  };

  const handleExportAllExcel = async () => {
    try {
      if (isExporting) return;
      setExportMode("all");
      setIsExporting(true);
      if (!ordergroupToltal || ordergroupToltal <= 0) {
        errorSwal("ບໍ່ພົບຂໍ້ມູນ");
        return;
      }

      const _where = buildWhere();
      const allData = [];
      const batchSize = 500;
      let batch = 0;
      let total = ordergroupToltal;

      while (allData.length < total) {
        const result = await client.query({
          query: GET_ORDERGROUP_BATCH,
          variables: {
            where: _where,
            orderBy: "createdAt_DESC",
            batch,
            batchSize,
          },
          fetchPolicy: "network-only",
        });

        const pageData = result?.data?.orderGroupsBatch?.data || [];
        total = result?.data?.orderGroupsBatch?.total ?? total;
        allData.push(...pageData);
        if (pageData.length < batchSize) break;
        batch += 1;
      }

      const rows = buildExportRows(allData);
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `sale_history_all_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    } catch (error) {
      console.log("Export Error:", error);
      errorSwal("ສົ່ງອອກບໍ່ສຳເລັດ");
    } finally {
      setExportMode("");
      setIsExporting(false);
    }
  };

  return (
    <React.Fragment>
      <div>
        <BreadCrumbComponent
          // goback={() => history.goBack()}
          // txtFirst="ປະຫວັດການຂາຍ"
          txtSecond={`ຂໍ້ມູນການຂາຍ`}
        />
        <div style={{ padding: width > 700 ? "1em 2em" : 3 }}>
          <h4>
            <b>{t("sale_history_title")}</b>
          </h4>
          <p>{t("history_description")}</p>
        </div>

        <div style={{ margin: width > 700 ? ".3em 2em" : 3 }}>
          <Row>
            <Col sm>
              <Form.Label htmlFor="basic-url">{t("search_product_name")}</Form.Label>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon3">
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  value={searchText}
                  id="basic-url"
                  placeholder="....."
                  aria-describedby="basic-addon3"
                />
              </InputGroup>
            </Col>

            <Col>
              <Form.Label>{t("category_name_tb")}</Form.Label>
              {(_.isEmpty(newCategoryData) || getCategoryLoading) ? (<p>Category loading...</p>) : (
                <Form.Select
                  name="category"
                  onChange={(e) => {
                    const selectedOption = e?.target?.options[e?.target?.selectedIndex];
                    console.log("value", e?.target?.value);
                    console.log("text", selectedOption?.text);
                    setIsCategory(e?.target?.value);
                    setIsCategoryName(selectedOption?.text);
                  }}
                  value={isCategory}
                  size="md">
                  <option value="">
                    --ເລືອກ--
                  </option>
                  {newCategoryData.map((item, index) => (
                    <option key={index} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Col>

            <Col>
              <Form.Label>{t("customer_type")}</Form.Label>
                <Form.Select
                  name="userType"
                  onChange={(e) => setSelectUserType(e.target.value)}
                  value={selectUserType}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                  }}
                  aria-label="Default select example">
                  <option value="">
                    --{t("select_option")}--
                  </option>
                  {!_.isEmpty(newUserTypeData) && newUserTypeData.map((i) => (
                    <option key={i?.id} value={i?.id}>
                      {i?.name}
                    </option>
                  ))}
                </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label>{t("payment_method")}</Form.Label>
              <Form.Select
                onChange={(e) => setPayment(e?.target?.value)}
                size="md">
                <option value="">--{t("select_option")}--</option>
                <option value="CASH">{t("cash_money_name")}</option>
                <option value="TRANSFER">{t("transfer_money_name")}</option>
              </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label>{t("status")}</Form.Label>
              <Form.Select
                onChange={(e) => setSelectStatus(e?.target?.value)}
                value={selectStatus}
                size="md">
                <option value="">--{t("select_option")}--</option>
                <option value="COMPLETED">ສຳເລັດ</option>
                <option value="INDEBTED">ຕິດໜີ້</option>
                <option value="ALL">ທັງໝົດ</option>
              </Form.Select>
            </Col>

            <Col sm style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Form.Label>{t("day_month_year")}</Form.Label>

              <Button
                variant="outline-secondary"
                onClick={() => setIsCurrentModals(true)}
                style={{ textAlign: "left", marginTop: '-.2em', width: '100%' }}
              >
                {(loadingSaleOrder && !orderGroupsData) ? (
                  <Spinner size="sm" />
                ) : (
                  <MdOutlineDateRange style={{ fontSize: 24 }} />
                )}
                &nbsp;  &nbsp;
                {!filter ? (
                  "mm/dd/yyyy"
                ) : (
                  <>
                    {covertTimeZone(filter?.createdAt_gte) +
                      " - " +
                      covertTimeZone(filter?.createdAt_lt)}
                  </>
                )}
              </Button>
            </Col>
            <Col sm style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Form.Label>Export Excel</Form.Label>
              <CustomButton
                width="100%"
                height={40}
                borderRadius="8px"
                background="green"
                color="#fff"
                title={isExporting && exportMode === "page" ? "ກຳລັງບັນທຶກ..." : "Export Excel"}
                disabled={isExporting}
                onClick={handleExportExcel}
              />
              <CustomButton
                width="100%"
                height={40}
                borderRadius="8px"
                background="green"
                color="#fff"
                title={isExporting && exportMode === "all" ? "ກຳລັງບັນທຶກ..." : "Export ທັງໝົດ"}
                disabled={isExporting}
                onClick={handleExportAllExcel}
              />
            </Col>
          </Row>
        </div>

        <div
          style={{
            margin: width > 700 ? "1em 2em" : 3,
            backgroundColor: "#fff",
            borderRadius: "5px",
          }}>
          {loadingSaleOrder && !orderGroupsData?.orderGroups ? (
            <div style={{ height: '70vh' }}>
              <AnimationLoading />
            </div>
          ) : (
            <>
              {ordergroup?.length > 0 ? (
                <Table
                  responsive
                  hover
                  style={{
                    // marginTop: "-1em",
                    borderCollapse: "collapse",
                    width: "100% ",
                    cursor: 'pointer'
                  }}>
                  <thead
                    style={{
                      background: LINEAR_GRADIENT_BG,
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      <th>#</th>
                      <th>{t("number_no")}</th>
                      <th>{t("customer_name")}</th>
                      <th>{t("customer_type")}</th>
                      <th>{t("category_name_tb")}</th>
                      <th>{t("phone_number")}</th>
                      <th>{t("qty_name_tb")}</th>
                      <th>{t("total_price_tb")}</th>
                      <th>{t("payment_method")}</th>
                      <th>{t("status")}</th>
                      <th>{t("day_month_year")}</th>
                      <th style={{ textAlign: 'right' }}>
                        {["DELETE_HISTORY_BILL"].some(permission => rolePermissions.includes(permission)) && t("action_tb")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordergroup
                      ?.filter((salehis) => {
                        if (selectStatus === "ALL") return true;
                        if (selectStatus === "") return salehis.status !== "INDEBTED";
                        return salehis.status === selectStatus;
                      })
                      .map((salehis, index) => (

                        <tr
                          key={index}
                          className="saleRows"
                          onClick={() =>
                            handleCheck(salehis)
                          }>
                          <td style={{ minWidth: 50 }}>{index + 1 + _limit * (_skip - 1)}</td>
                          <td style={{ minWidth: 100 }}>{formatBillCode(salehis)}</td>
                          <td style={{ minWidth: 100 }}>{salehis?.customerName ?? "-"}</td>
                          <td style={{ minWidth: 100 }}>{salehis?.userConfirm?.userType?.name ?? "-"}</td>
                          <td style={{ minWidth: 100 }}>
                            {salehis?.orders && salehis?.orders?.length > 0
                              ? (!_.isEmpty(Array.from(new Set(salehis?.orders.map(order => order?.stock?.category?.name).filter(Boolean))).join(', '))
                                ? Array.from(new Set(salehis?.orders.map(order => order?.stock?.category?.name).filter(Boolean))).join(', ')
                                : Array.from(new Set(salehis?.orders.map(order => order?.stock?.categoryName).filter(Boolean))).join(', '))
                              : '-'}
                          </td>
                          <td style={{ minWidth: 100 }}>{salehis?.phone ?? "-"}</td>
                          <td style={{ minWidth: 100 }}>{salehis?.amount ?? ""}</td>
                          <td style={{ minWidth: 100 }}>
                            {convertCurrency("LAK")}{" "}
                            {numberFormat(salehis?.receivedMoney || salehis?.sumPrice)}
                          </td>
                          <td style={{ minWidth: 100 }}>
                            {" "}
                            {salehis.payment === "CASH"
                              ? t("cash_money_name")
                              : t("transfer_money_name")}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                              minWidth: 100,
                            }}>
                            <Badge bg={salehis?.status === "COMPLETED" ? "success" : salehis?.status === "CANCELLED" ? "danger" : salehis?.status === "WAITINGCONFIRM" ?  "warning" : "secondary"}>
                              {convertOrderStatus(salehis?.status) ?? ""}
                            </Badge>
                          </td>
                          <td style={{ minWidth: 100 }}>
                            {covertTimeZone(salehis?.createdAt)}

                          </td>
                          {["DELETE_HISTORY_BILL"].some(permission => rolePermissions.includes(permission)) && <td align="right" onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <CustomButton
                                width={40}
                                borderRadius="8px"
                                background="#3b82f6"
                                color="#fff"
                                icon={
                                  <EditIcon sx={{ color: "#fff", fontSize: 18 }} />
                                }
                                onClick={() =>
                                  handleShowEdit(salehis)
                                }
                              />
                              <CustomButton
                                width={40}
                                borderRadius="8px"
                                background="#dc2626"
                                color="#fff"
                                icon={
                                  <DeleteIcon sx={{ color: "#fff", fontSize: 18 }} />
                                }
                                onClick={() =>
                                  handleShowDelete(salehis?.id, salehis?.code)
                                }
                              />
                            </div>
                          </td>}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {ordergroup?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີປະຫວັດການຂາຍ !!!</p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        {ordergroupToltal > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: '1em 2em'
            }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {(ordergroupToltal && width > 700) && (
                <div className="show">
                  ກຳລັງສະແດງ {_limit * _skip - (_limit - 1)}-
                  {_limit * _skip > ordergroupToltal ? ordergroupToltal : _limit * _skip}{" "}
                  ຈາກ {ordergroupToltal}
                </div>
              )}
              <Form.Select
                value={String(_limit)}
                onChange={handleSelectLimit}
                style={{ width: 90 }}
              >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="150">150</option>
              </Form.Select>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div>ໜ້າ {_skip}</div>
              <div>{Pagination_helper(ordergroupToltal, "", ``)}</div>
            </div>

          </div>
        ) : (
          ""
        )}
      </div>

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={_confirmeDelete}
        title="ແຈ້ງເຕືອນ"
        text={`ທ່ານຕອ້ງການລົບຂໍ້ມູນ ${Delete?.code} ນີ້ເເທ້ບໍ່!`}
        loadingConfirm={deleteloading}
      />

      {/* Edit Modal */}
      <Modal show={showEdit} onHide={() => setShowEdit(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>ແກ້ໄຂຂໍ້ມູນອໍເດີ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrderData && (
            <div>
              {/* Order Information Display */}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label><strong>ລະຫັດອໍເດີ:</strong></Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedOrderData?.code || ""}
                      readOnly
                      style={{ backgroundColor: '#f8f9fa' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label><strong>ລູກຄ້າ:</strong></Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedOrderData?.userConfirm?.userType?.name || "-"}
                      readOnly
                      style={{ backgroundColor: '#f8f9fa' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label><strong>ສະຖານະ:</strong></Form.Label>
                    <div style={{ padding: '8px 0' }}>
                      <Badge bg={selectedOrderData?.status === "COMPLETED" ? "success" : selectedOrderData?.status === "CANCELLED" ? "danger" : selectedOrderData?.status === "WAITINGCONFIRM" ? "warning" : "secondary"}>
                        {convertOrderStatus(selectedOrderData?.status) || ""}
                      </Badge>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label><strong>ວັນທີ່ສ້າງ:</strong></Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedOrderData?.checkBillDate ? covertTimeZone(selectedOrderData?.checkBillDate) : covertTimeZone(selectedOrderData?.createdAt)}
                      readOnly
                      style={{ backgroundColor: '#f8f9fa' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <hr />

              {/* Editable Field */}
              <Form.Group className="mb-3">
                <Form.Label><strong>ວັນທີ່ເຊັກບິນ (ສາມາດແກ້ໄຂໄດ້):</strong></Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={editCheckBillDate}
                  onChange={(e) => setEditCheckBillDate(e.target.value)}
                />
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEdit(false)}>
            ຍົກເລີກ
          </Button>
          <Button variant="primary" onClick={handleEditSubmit}>
            ບັນທຶກ
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <ComfirmModal
        showConfirmModal={showConfirm}
        handleCancel={() => setShowConfirm(false)}
        handleConfirm={handleConfirmEdit}
        title="ຢືນຢັນການແກ້ໄຂ"
        text="ທ່ານຕ້ອງການບັນທຶກການແກ້ໄຂນີ້ແທ້ບໍ່?"
        loadingConfirm={updateLoading}
      />

      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setFilter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </React.Fragment>
  );
}
